import axios from 'axios'
import qs from 'qs'

const vinApi: any = {}


let lang = window.localStorage.getItem("lang") || 'zh'
if(lang === 'zh' || lang === 'tr' || lang === 'cht') {
  lang = 'cn'
}

vinApi.vin = (params: {}): Promise<{}>=>{
  params = {...params, language_mark: lang}
  return axios.get('/v1/api/epc/cars/vin/oo7', { params })
}
vinApi.getSimplifyCars = (params: {}): Promise<{}>=>{
  params = {...params, language_mark: lang}
  return axios.get('/v1/api/epc/epc/vin/group/model', { params })
}
vinApi.group = (params: {}): Promise<{}>=>{
  params = {...params, language_mark: lang}
  return axios.get('/v1/api/epc/cars/group', { params })
}
vinApi.structure = (params: {}): Promise<{}>=>{
  params = {...params, language_mark: lang}
  return axios.get('/v1/api/epc/cars/structure', { params })
}
vinApi.subGroup = (params: {}): Promise<{}>=>{
  params = {...params, language_mark: lang}
  return axios.get('/v1/api/epc/cars/structure/subs', { params })
}
vinApi.config = (params: {}): Promise<{}>=>{
  params = {...params, language_mark: lang}
  return axios.get('/v1/api/epc/cars/config/search', { params })
}
vinApi.points = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/structimgs/points", {params})
}
vinApi.partnew = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/vin/part/ai", {params})
}
vinApi.part = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/part", {params})
}

vinApi.config = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/config", {params})
}
vinApi.configSearch = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/config/search", {params})
}
vinApi.tag = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/part/tags", {params})
}
vinApi.getStandardLabel = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/engine/search/stdname_remake", {params})
}

vinApi.baseinfo = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/parts/baseinfo", {params})
}
vinApi.replace = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/parts/replace", {params})
}
vinApi.stocks = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.post("/v1/cactus/user/zhb/match/stocks/simple", params)
}
vinApi.articles = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/parts/articles", {params})
}
vinApi.applicable = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/parts/generacars", {params})
}
vinApi.freeApplicable = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/cstnl/parts/generacars", {params})
}
vinApi.pics = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/user/ugc/part/pics", {params})
}
vinApi.removePic = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/user/ugc/part/picdel", {params})
}

vinApi.getMaintenancePoint = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/maintenance/sub/group/struct", {params})
}
vinApi.getMaintenancePart = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/cars/maintenance/sub/group/parts", {params})
}

vinApi.searchKey = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.post("/v1/api/epc/engine/parts/search_key_v2", qs.stringify(params))
}

vinApi.searchHot = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/engine/parts/search_name_v2", {params})
}

vinApi.partSearch = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/engine/parts/search", {params})
}
vinApi.partPrice = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/epc/parts/price", {params})
}
vinApi.buyPartPrice = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/webcst/oe/price", {params})
}
vinApi.setHistory = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.post("/v1/api/webcst/search/history", params)
}
vinApi.getHistory = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/webcst/search/history", {params})
}
vinApi.getDmsBrand = (params: {}): Promise<{}> => {
  params = {...params, language_mark: lang}
  return axios.get("/v1/api/webcst/dms/brand", {params})
}

vinApi.ocr = (params: {}): Promise<{}> => {
  // params = {...params, language_mark: lang}
  return axios.post("/v1/api/epc/ocr/parse", params)
}
vinApi.ocrPath = '/v1/api/epc/ocr/parse'

export default vinApi